let load = require('./helpers/browser/esm-js-loader');
module.exports = Promise.all([load("3R6XQ"), load("1xLoT")]).then(() => parcelRequire('kjSSV'));